'use client';
import AppLayout from '@/components/AppLayout';
import SupplierAnalyticsContent from './components/SupplierAnalyticsContent';

export default function SupplierAnalyticsPage() {
  return (
    <AppLayout>
      <SupplierAnalyticsContent />
    </AppLayout>
  );
}
